export enum TaxReceiptType {
  CASH_RECEIPT_PERSONAL = 'CASH_RECEIPT_PERSONAL',
  CASH_RECEIPT_BUSINESS = 'CASH_RECEIPT_BUSINESS',
  TAX_INVOICE = 'TAX_INVOICE',
}

export enum ReceiptStatus {
  PENDING = 'PENDING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  SKIPPED = 'SKIPPED', // 발급 불필요 -> 현재는 사용되지 않음 (표시할 케이스 없음)
}
